import React from 'react';
import { Row } from 'antd';
import { Formik, Form } from 'formik';
import COSelect from 'shared/components/COSelect';
import EditGoalModal from 'shared/components/EditGoalModal';
import ProductDashboardCard from 'views/Products/ProductDashboardCard';
import styles from '../ProductDashboardCharts.module.scss';
import clsx from 'clsx';
import { ProductDashboardChartsViewProps } from 'enums/ProductDashboardChartsEnums';
import { Product } from 'models/Product/product.model';
import {
  DashboardGoalInterface,
  GoalProduct,
} from 'services/DashboardService/dashboard.service';
import { ProductStagesEnums } from 'enums/ProductStagesEnums';

const b2bDropdownClass = clsx(styles.fieldContainer);

interface CarbonFootprintSectionProps {
  productCarbonFootprintOptions: {
    value: string;
  }[];
  handleChangeCard: (values: ProductStagesEnums) => void;
  editModalProductState: boolean;
  handleEditProductModal: () => void;
  goalProduct: GoalProduct | null;
  setGoal: (goal: DashboardGoalInterface) => Promise<void>;
  updateGoal: (goal: DashboardGoalInterface) => Promise<void>;
  productId: number;
  totalEmissionAnnualProduction?: number;
  handleOpenProductModal: () => void;
  newProduct?: Product;
}

const CarbonFootprintSection: React.FC<CarbonFootprintSectionProps> = ({
  productCarbonFootprintOptions,
  handleChangeCard,
  editModalProductState,
  handleEditProductModal,
  goalProduct,
  setGoal,
  updateGoal,
  productId,
  totalEmissionAnnualProduction,
  handleOpenProductModal,
  newProduct,
}) => {
  return (
    <Row className={styles.carbonFootPrintContainer}>
      <div className={styles.carbonFootPrintWrapper}>
        <div className={styles.annualProductionHeaderContainer}>
          <div className={styles.annualProductionHeading}>
            <h3>{ProductDashboardChartsViewProps.CARD_ONE_HEADING}</h3>
          </div>
          <div className={styles.annualProductionFieldsContainer}>
            <Formik
              initialValues={{
                category: 'B2B',
              }}
              onSubmit={() => {}}>
              <Form>
                <div className={b2bDropdownClass}>
                  <COSelect
                    name="category"
                    options={productCarbonFootprintOptions}
                    placeholderstring="Category"
                    defaultValue={productCarbonFootprintOptions[0].value}
                    onChange={handleChangeCard}
                    allowClear={false}
                  />
                </div>
              </Form>
            </Formik>
          </div>
        </div>
        <div className={styles.goalContainer}>
          <EditGoalModal
            heading={ProductDashboardChartsViewProps.EDIT_GOAL_HEADING}
            showModalState={editModalProductState}
            handleModalConfirm={handleEditProductModal}
            handleModalCancel={handleEditProductModal}
            preFetchedData={goalProduct}
            setGoal={setGoal}
            updateGoal={updateGoal}
            type="product"
            productId={productId}
          />
          <ProductDashboardCard
            annual
            goalAnnualProduction={goalProduct?.co2e}
            totalCarbonEmissionOfAnnualProduction={Number(
              totalEmissionAnnualProduction
            )}
            handleOpenModal={handleOpenProductModal}
          />
        </div>
      </div>

      <div className={styles.footPrintLabelContainer}>
        <div className={styles.footPrintLabelWrapper}>
          <div className={styles.footPrintLabelHeading}>
            <h3>{ProductDashboardChartsViewProps.CARD_TWO_HEADING}</h3>
          </div>
          <div className={styles.footPrintLabelCard}>
            <ProductDashboardCard
              labelValue={newProduct?.b2c}
              product={newProduct}
            />
          </div>
        </div>
      </div>
    </Row>
  );
};

export default CarbonFootprintSection;
